/**
 * CODELTY Core — Media controller
 *
 * Generic video state machine. Does not know products, categories, or sections.
 * Operates on [data-codelty-media-root] with primary/secondary slots.
 */

class CodeltyMediaController {
  static STATES = ['normal', 'hover', 'viewport', 'idle'];

  constructor(root) {
    this.root = root;
    this.state = 'idle';
    this.refresh();
  }

  refresh() {
    this.primarySlot = this.root.querySelector('[data-codelty-media-primary]');
    this.secondarySlot = this.root.querySelector('[data-codelty-media-secondary]');
    this.primaryVideo = this.primarySlot?.querySelector('video') ?? null;
    this.secondaryVideo = this.secondarySlot?.querySelector('video') ?? null;
    this.hasSecondary = Boolean(this.secondarySlot);
  }

  setState(nextState) {
    if (!CodeltyMediaController.STATES.includes(nextState)) return;
    if (this.state === nextState) return;
    this.state = nextState;
    this.apply();
  }

  apply() {
    switch (this.state) {
      case 'normal':
        this.pauseVideo(this.secondaryVideo, true);
        this.playVideo(this.primaryVideo);
        break;
      case 'hover':
        this.pauseVideo(this.primaryVideo);
        this.playVideo(this.secondaryVideo);
        break;
      case 'viewport':
        this.pauseVideo(this.secondaryVideo, true);
        this.playVideo(this.primaryVideo);
        break;
      case 'idle':
        this.pauseVideo(this.primaryVideo);
        this.pauseVideo(this.secondaryVideo, true);
        break;
    }
  }

  playVideo(video) {
    if (!video) return;
    video.play().catch(() => {});
  }

  pauseVideo(video, reset = false) {
    if (!video) return;
    video.pause();
    if (reset) video.currentTime = 0;
  }
}

window.CodeltyMediaController = CodeltyMediaController;
